


// import React, { useState, useMemo, useEffect, useCallback } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { Modal, Button, Form, Dropdown, DropdownButton, Pagination } from 'react-bootstrap';
// import { FaStar } from 'react-icons/fa';
// import { addReview, updateProductReviews,selectAverageRating, selectNumberOfReviews,selectCombinedReviewsByProductId } from '../redux/reviewSlice';
// import { selectProducts } from '../redux/productSlice'; 
// import '../css/rating.css';
// import StartRating from './starRating';
// import { ProgressBar } from 'react-bootstrap';
// import { toast } from "react-toastify";
// import { BsArrowDownUp, BsFunnel } from 'react-icons/bs';
// // import { selectAverageRating, selectNumberOfReviews,selectCombinedReviewsByProductId } from '../utils/reviewSelector'


// const ReviewForm = ({ productId }) => {
//   const products = useSelector(selectProducts); 
//   const [name, setName] = useState('');
//   const [reviewText, setReviewText] = useState('');
//   const [rating, setRating] = useState(0);
//   const [hover, setHover] = useState(null);
//   const [showModal, setShowModal] = useState(false);
//   const [modalMessage, setModalMessage] = useState('');
//   const [isAnonymous, setIsAnonymous] = useState(false);
//   const [sortOrder, setSortOrder] = useState('recent-to-old');
//   const [filteredRating, setFilteredRating] = useState('all'); // Default to show all reviews
//   const [currentPage, setCurrentPage] = useState(1); // Current page for pagination
//   const product = products.find((prod) => prod.id === productId);


//   const dispatch = useDispatch();


//   const reviews = useSelector((state) => selectCombinedReviewsByProductId(state, productId));
//   const averageRating = useSelector(
//     useCallback((state) => selectAverageRating(state, productId), [productId])
//   );
  
//   const numberOfReviews = useSelector(
//     useCallback((state) => selectNumberOfReviews(state, productId), [productId])
//   );
//   console.log(reviews)

//   // const updatedReviews = useSelector((state) => selectCombinedReviewsByProductId(state, productId));
//   const [reviewSubmitted, setReviewSubmitted] = useState(false);

//   // Pagination setup
//   const reviewsPerPage = 10;
  
//   const filteredReviews = useMemo(() => {
//     let filtered = filteredRating === 'all'
//       ? reviews
//       : reviews.filter((review) => review.PersonRating === parseInt(filteredRating));

  //   // Sort reviews
  //   filtered = sortOrder === 'recent-to-old'
  //     ? filtered.slice().reverse()
  //     : filtered;

  //   return filtered;
  // }, [filteredRating, reviews, sortOrder]);

//   // Calculate total pages based on the filtered reviews
//   const totalPages = Math.ceil(filteredReviews.length / reviewsPerPage);

//   // Get the current page's reviews
//   const currentReviews = filteredReviews.slice(
//     (currentPage - 1) * reviewsPerPage,
//     currentPage * reviewsPerPage
//   );

//   // Handle pagination
//   const paginate = (pageNumber) => setCurrentPage(pageNumber);

//   // Reset to page 1 when filters or sort order change
//   useEffect(() => {
//     setCurrentPage(1);
//   }, [filteredRating, sortOrder]);

//   const ratingCounts = reviews.reduce(
//     (acc, review) => {
//       acc[review?.PersonRating]++;
//       return acc;
//     },
//     { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 }
//   );

//   const totalReviews = reviews.length;

//   useEffect(() => {
//     if (reviewSubmitted) {
//       setReviewSubmitted(false);
//     }
//   }, [reviews, productId, reviewSubmitted]);

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (reviewText.trim() === '') {
//       setModalMessage('Please write your review.');
//       setShowModal(true);
//       return;
//     }
//     if (!isAnonymous && name.trim() === '') {
//       setModalMessage('Please provide your name or choose to post anonymously.');
//       setShowModal(true);
//       return;
//     }
//     if (rating === 0) {
//       setModalMessage('Please provide a rating.');
//       setShowModal(true);
//       return;
//     }

//     const newReview = {
//       name: isAnonymous ? 'Anonymous' : name.trim(),
//       PersonRating: rating,
//       review: reviewText.trim(),
//     };

//     dispatch(addReview({ productId, newReview }));
//     dispatch(updateProductReviews({ productId, newReview }));
//     setReviewSubmitted(true);
//     toast.success("Review added successfully!");
//     setName('');
//     setReviewText('');
//     setRating(0);
//     setIsAnonymous(false);
//   };

//   const sortOrderLabel = sortOrder === 'recent-to-old' ? 'Recent to Old' : 'Old to Recent';

//   return (
//     <div className='ratingReview'>
//       <h3>Ratings & Reviews of {product?.name}</h3>
//       <div className='avarageRatingProgressBar d-flex w-100 gap-5 align-items-center mt-2'>
//         <div className='avarageRating'>
//           <p className='avarageRatingPoint'>{averageRating.toFixed(1)}<span>/5</span></p>
//           <ul id="stars" className="d-flex list-unstyled p-0 m-0">
//             {/* <StartRating productRating={averageRating} /> */}
//             <StartRating productRating={averageRating || 0} numberOfReviews={numberOfReviews || 0} />
//           </ul>
//           <span className='avarageRatingMan'>{numberOfReviews} Reviews</span>
//         </div>
//         <div className='ratingProgressBar w-100'>
//           {Object.entries(ratingCounts)
//             .reverse() // Show 5-star first
//             .map(([stars, count]) => (
//               <div key={stars} className="d-flex align-items-center mb-2">
//                 <div className="star-label">
//                   <span>{stars}</span> <FaStar />
//                 </div>
//                 <ProgressBar
//                   now={(count / totalReviews) * 100}
//                   label={`${count}`}
//                   className="flex-grow-1 mx-0"
//                 />
//               </div>
//             ))}
//         </div>
//       </div>
//       <div className='d-flex justify-content-between align-items-center product-Review-rating'>
//         <h6>Product Review</h6>
//         <div className='d-flex gap-2 align-items-center flex-row'>
//           <div className="sort-dropdown ">
//             <DropdownButton id="sort-order-dropdown" title={<><BsArrowDownUp /> <span>Sort:</span>  {sortOrderLabel}</>}>
//               <Dropdown.Item 
//                 active={sortOrder === 'recent-to-old'} 
//                 onClick={() => setSortOrder('recent-to-old')}
//               >
//                 Recent to Old
//               </Dropdown.Item>
//               <Dropdown.Item 
//                 active={sortOrder === 'old-to-recent'} 
//                 onClick={() => setSortOrder('old-to-recent')}
//               >
//                 Old to Recent
//               </Dropdown.Item>
//             </DropdownButton>
//           </div>
//           <div className="filter-dropdown ">
//             <DropdownButton id="dropdown-basic-button" title={<><BsFunnel /> <span>Filter: </span> {filteredRating === 'all' ? 'All Stars' : filteredRating + ' Star'}</>}>
//               <Dropdown.Item active={filteredRating === 'all'} onClick={() => setFilteredRating('all')}>
//                 All Stars
//               </Dropdown.Item>
//               <Dropdown.Item active={filteredRating === 5} onClick={() => setFilteredRating(5)}>
//                 5 Stars
//               </Dropdown.Item>
//               <Dropdown.Item active={filteredRating === 4} onClick={() => setFilteredRating(4)}>
//                 4 Stars
//               </Dropdown.Item>
//               <Dropdown.Item active={filteredRating === 3} onClick={() => setFilteredRating(3)}>
//                 3 Stars
//               </Dropdown.Item>
//               <Dropdown.Item active={filteredRating === 2} onClick={() => setFilteredRating(2)}>
//                 2 Stars
//               </Dropdown.Item>
//               <Dropdown.Item active={filteredRating === 1} onClick={() => setFilteredRating(1)}>
//                 1 Star
//               </Dropdown.Item>
//             </DropdownButton>
//           </div>
//         </div>
//       </div>

//       <div className="filtered-reviews mt-1">
//         {currentReviews.length > 0 ? (
//           currentReviews.map((review, index) => (
//             <div key={index} className="review-item">
//               <div className='d-flex align-items-center gap-1'>
//                 <strong>{review.name}</strong> 
//                 <ul id="stars" className="d-flex list-unstyled p-0 m-0">
//                   <StartRating productRating={review.PersonRating} />
//                 </ul>
//               </div>
//               <p>{review.review}</p>
//             </div>
//           ))
//         ) : (
//           <p className='mt-3 mb-3'><img src='../imgs/noreview.gif' alt="No reviews available"/></p>
//         )}
//      <div className='custom-pagination-rq'>
//              {filteredReviews.length > reviewsPerPage && (
//           <Pagination className="mt-3">
//             {/* <Pagination.First onClick={() => paginate(1)} /> */}
//             <Pagination.Prev onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} />

//             {/* Display pagination items */}
//             {[...Array(totalPages).keys()].map((number) => {
//               // Always show the first three pages
//               if (number < 3) {
//                 return (
//                   <Pagination.Item key={number + 1} active={number + 1 === currentPage} onClick={() => paginate(number + 1)}>
//                     {number + 1}
//                   </Pagination.Item>
//                 );
//               }
              
//               // Show the current page and one before and after
//               if (number === currentPage - 1 || number === currentPage || number === currentPage + 1) {
//                 return (
//                   <Pagination.Item key={number + 1} active={number + 1 === currentPage} onClick={() => paginate(number + 1)}>
//                     {number + 1}
//                   </Pagination.Item>
//                 );
//               }

//               // Show ellipsis after first three pages
//               if (number === 3 && currentPage > 4) {
//                 return <Pagination.Ellipsis key="ellipsis1" />;
//               }

//               // Show the last two pages
//               if (number >= totalPages - 2) {
//                 return (
//                   <Pagination.Item key={number + 1} active={number + 1 === currentPage} onClick={() => paginate(number + 1)}>
//                     {number + 1}
//                   </Pagination.Item>
//                 );
//               }

//               return null; // Return null for other cases
//             })}

//             <Pagination.Next onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages} />
//             {/* <Pagination.Last onClick={() => paginate(totalPages)} /> */}
//           </Pagination>
//         )}
//      </div>
 

//       </div>
//      <h4>Leave a Review</h4>
//     <div className='reviewfromLeave'>
//         <Form onSubmit={handleSubmit}>
//           <Form.Group controlId="anonymousCheck">
//             <Form.Check
//               type="checkbox"
//               label="Post as Anonymous"
//               checked={isAnonymous}
//               onChange={(e) => setIsAnonymous(e.target.checked)}
//             />
//           </Form.Group>
//           {!isAnonymous && (
//             <Form.Group controlId="name">
//               <Form.Label>Your Name</Form.Label>
//               <Form.Control
//                 type="text"
//                  placeholder="Enter your name"
//                 value={name}
//                 onChange={(e) => setName(e.target.value)}
//               />
//             </Form.Group>
//           )}
//           <Form.Group controlId="reviewText">
//             <Form.Label>Your Review</Form.Label>
//             <Form.Control
//               as="textarea"
//               rows={3}
//               placeholder="Write your review..."
//               value={reviewText}
//               onChange={(e) => setReviewText(e.target.value)}
//             />
//           </Form.Group>
//           <Form.Group controlId="rating">
//             <Form.Label className='mt-1'>Your Rating</Form.Label>
//             <div className="star-rating" >
//               {[...Array(5)].map((star, index) => {
//                 const starRating = index + 1;
//                 return (
//                   <label key={index}>
//                     <input
//                       type="radio"
//                       name="rating"
//                       value={starRating}
//                       onClick={() => setRating(starRating)}
//                     />
//                     <FaStar
//                       className="star"
//                       color={starRating <= (hover || rating) ? '#ffc107' : '#e4e5e9'}
//                       size={20}
//                       onMouseEnter={() => setHover(starRating)}
//                       onMouseLeave={() => setHover(null)}
//                     />
//                   </label>
//                 );
//               })}
//             </div>
//           </Form.Group>
//           <Button variant="primary" type="submit">
//             Submit Review
//           </Button>
//         </Form>
//       </div>
//       <Modal show={showModal} onHide={() => setShowModal(false)}>
//         <Modal.Header closeButton>
//           <Modal.Title>Warning</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>{modalMessage}</Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setShowModal(false)}>
//             Close
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// };

// export default ReviewForm;


// import React, { useState, useEffect, useMemo } from 'react'; 
// import { useDispatch, useSelector } from 'react-redux'; 
// import { addReview, initializeReviews, selectReviews } from '../redux/reviewSlice'; 
// import { selectProducts } from '../redux/productSlice';
// // import {selectAverageRating,selectNumberOfReviews } from '../utils/calculateRatingReview'
// import { selectCombinedReviews, selectAverageRating, selectNumberOfReviews } from '../utils/reviewSelector';


// const ReviewForm = ({ productId }) => {
//   const products = useSelector(selectProducts);
//   const reviews = useSelector(selectReviews);
//   const dispatch = useDispatch();

//   // Get the product by ID
//   const product = products.find(p => p.id === productId);
//   const staticReviews = product?.reviewsList || [];
//   const combinedReviewsList = useSelector(selectCombinedReviews(product?.id));
//   const averageRating = selectAverageRating(combinedReviewsList);
//   const numberOfReviews = selectNumberOfReviews(combinedReviewsList);

//   useEffect(() => {
    
//     // Initialize the static reviews in Redux store only once
//     if (!reviews[productId] && staticReviews.length > 0) {
//       dispatch(initializeReviews({ productId, existingReviews: staticReviews }));
//     }
//   }, [dispatch, productId, staticReviews, reviews]);

//   // Ensure that the reviews for the specific productId are defined



//   const [name, setName] = useState('');
//   const [rating, setRating] = useState(0);
//   const [review, setReview] = useState('');




//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const newReview = { name, PersonRating: rating, review };

//     // Dispatch the action to add the new review
//     dispatch(addReview({ productId, newReview }));

//     // Reset form fields
//     setName('');
//     setRating(0);
//     setReview('');
//   };

//   // Check if combined reviews exist before rendering
//   return (
//     <div>
//       <h2>Submit a Review</h2>
//       <form onSubmit={handleSubmit}>
//         <input
//           type="text"
//           value={name}
//           onChange={(e) => setName(e.target.value)}
//           placeholder="Your Name"
//           required
//         />
//         <input
//           type="number"
//           value={rating}
//           onChange={(e) => setRating(Number(e.target.value))}
//           placeholder="Rating (1-5)"
//           min="1"
//           max="5"
//           required
//         />
//         <textarea
//           value={review}
//           onChange={(e) => setReview(e.target.value)}
//           placeholder="Your Review"
//           required
//         />
//         <button type="submit">Submit Review</button>
//       </form>

//   <h3>Total Reviews: {numberOfReviews}</h3>
//       <h4>Average Rating: {averageRating}</h4> {/* Display average rating */}
     
//       <h4>Existing Reviews:</h4>
//       <ul>
//         {combinedReviewsList.map((rev, index) => (
//           <li key={index}>
//             <strong>{rev.name}:</strong> {rev.PersonRating} - {rev.review}
//           </li>
//         ))}
//       </ul>
//     </div>
//   );
// };

// export default ReviewForm;




import React, { useState, useEffect, useMemo } from 'react';  
import { useDispatch, useSelector } from 'react-redux';
import { Form, Button, Modal, Pagination, DropdownButton, Dropdown, ProgressBar } from 'react-bootstrap';
import { FaStar } from 'react-icons/fa';
import { toast } from "react-toastify";
import '../css/rating.css';
import { BsFunnel, BsArrowDownUp } from 'react-icons/bs';
import { addReview, initializeReviews, selectReviews } from '../redux/reviewSlice';
import { selectProducts } from '../redux/productSlice';
import { selectCombinedReviews, selectAverageRating, selectNumberOfReviews } from '../utils/reviewSelector';
import StartRating from './starRating';

const ReviewForm = ({ productId }) => {
  const products = useSelector(selectProducts);
  const reviews = useSelector(selectReviews);
  const dispatch = useDispatch();

  const product = products.find(p => p.id === productId);
  const staticReviews = product?.reviewsList || [];
  const combinedReviewsList = useSelector(selectCombinedReviews(product?.id));
  const averageRating = selectAverageRating(combinedReviewsList);
  const numberOfReviews = selectNumberOfReviews(combinedReviewsList);

  useEffect(() => {
    if (!reviews[productId] && staticReviews.length > 0) {
      dispatch(initializeReviews({ productId, existingReviews: staticReviews }));
    }
  }, [dispatch, productId, staticReviews, reviews]);

  const [name, setName] = useState('');
  const [rating, setRating] = useState(0);
  const [review, setReview] = useState('');
  const [isAnonymous, setIsAnonymous] = useState(false);
  const [filteredRating, setFilteredRating] = useState(5);
  const [sortOrder, setSortOrder] = useState('recent-to-old');
  const [currentPage, setCurrentPage] = useState(1);
  const [reviewsPerPage] = useState(10);
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [hover, setHover] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
  if (!isAnonymous && name.trim() === '') {
      setModalMessage('Please provide your name or choose to post anonymously.');
      setShowModal(true);
      return;
  }
    if (review.trim() === '') {
      setModalMessage('Please write your review.');
      setShowModal(true);
      return;
  }



  // Check if the rating is not selected
  if (rating === 0) {
      setModalMessage('Please provide a rating.');
      setShowModal(true);
      return;
  }


    const newReview = { name: isAnonymous ? "Anonymous" : name, PersonRating: rating, review };

    dispatch(addReview({ productId, newReview }));
    setName('');
    setRating(0);
    setReview('');
    setIsAnonymous(false);
    toast.success("Review added successfully!");
   
  };

  // Filter and Sort Logic
  const filteredReviews = useMemo(() => {
    const filtered = filteredRating === 'all' 
      ? combinedReviewsList 
      : combinedReviewsList.filter(rev => rev.PersonRating === filteredRating);

    return sortOrder === 'recent-to-old' 
      ? filtered.slice().reverse() 
      : filtered;
  }, [filteredRating, combinedReviewsList, sortOrder]);

  const indexOfLastReview = currentPage * reviewsPerPage;
  const indexOfFirstReview = indexOfLastReview - reviewsPerPage;
  const currentReviews = filteredReviews.slice(indexOfFirstReview, indexOfLastReview);
  const totalPages = Math.ceil(filteredReviews.length / reviewsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Reset pagination to first page when filter or sort order changes
  useEffect(() => {
    setCurrentPage(1);
  }, [filteredRating, sortOrder]);

  // Calculate rating counts for progress bars
  const ratingCounts = combinedReviewsList.reduce((acc, review) => {
    acc[review?.PersonRating]++;
    return acc;
  }, { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 });

  const totalReviews = numberOfReviews; // You can directly use numberOfReviews

  return (
      <div className='ratingReview'>
        <h3>Ratings & Reviews of {product?.name}</h3>
        <div className='avarageRatingProgressBar d-flex w-100 gap-5 align-items-center mt-2'>
          <div className='avarageRating'>
            <p className='avarageRatingPoint'>{averageRating}<span>/5</span></p>
            <ul id="stars" className="d-flex list-unstyled p-0 m-0">
              {/* <StartRating productRating={averageRating} /> */}
              <StartRating productRating={averageRating || 0} numberOfReviews={numberOfReviews || 0} />
            </ul>
            <span className='avarageRatingMan'>{numberOfReviews} Reviews</span>
          </div>
          <div className='ratingProgressBar w-100'>
          {Object.entries(ratingCounts)
            .reverse() // Show 5-star first
            .map(([stars, count]) => (
              <div key={stars} className="d-flex align-items-center mb-2">
                <div className="star-label">
                  <span>{stars}</span> <FaStar />
                </div>
                <ProgressBar
                  now={totalReviews > 0 ? (count / totalReviews) * 100 : 0} // Prevent division by zero
                  label={`${count}`}
                  className="flex-grow-1 mx-0"
                />
              </div>
            ))}
        </div>
      </div>
      <div className='d-flex justify-content-between align-items-center product-Review-rating'>
         <h6>Product Review</h6>
          <div className='d-flex gap-2 align-items-center flex-row'>
            <div className="sort-dropdown">
                <DropdownButton id="sort-order-dropdown" title={<><BsArrowDownUp /> <span>Sort:</span>  {sortOrder === 'recent-to-old' ? 'Recent to Old' : 'Old to Recent'}</>}>
                  <Dropdown.Item active={sortOrder === 'recent-to-old'} onClick={() => setSortOrder('recent-to-old')}>
                    Recent to Old
                  </Dropdown.Item>
                  <Dropdown.Item active={sortOrder === 'old-to-recent'} onClick={() => setSortOrder('old-to-recent')}>
                    Old to Recent
                  </Dropdown.Item>
                </DropdownButton>
            </div>
            <div className="filter-dropdown">
              <DropdownButton id="filter-rating-dropdown" title={<><BsFunnel /> <span>Filter: </span> {filteredRating === 'all' ? 'All Stars' : filteredRating + ' Star'}</>}>
                <Dropdown.Item active={filteredRating === 'all'} onClick={() => setFilteredRating('all')}>
                All Stars
               </Dropdown.Item>
                {[...Array(5)].map((_, index) => (
                <Dropdown.Item key={index + 1} active={filteredRating === index + 1} onClick={() => setFilteredRating(index + 1)}>
                  {index + 1} Star
                </Dropdown.Item>
                ))}
              </DropdownButton>
            </div>
          </div>
      </div>
     <div className="filtered-reviews mt-1">
         {currentReviews.length > 0 ? (
            currentReviews.map((review, index) => (
              <div key={index} className="review-item">
                <div className='d-flex align-items-center gap-1'>
                  <strong>{review.name}</strong> 
                  <ul id="stars" className="d-flex list-unstyled p-0 m-0">
                    <StartRating productRating={review.PersonRating} />
                  </ul>
                </div>
                <p>{review.review}</p>
              </div>
            ))
          ) : (
            <p className='mt-3 mb-3'><img src='../imgs/noreview.gif' alt="No reviews available"/></p>
          )}
        <div className='custom-pagination-rq'>
          {filteredReviews.length > reviewsPerPage && (
            <Pagination className="mt-3">
              <Pagination.Prev onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} />
              {[...Array(totalPages).keys()].map((number) => {
                if (number < 3) {
                  return (
                    <Pagination.Item key={number + 1} active={number + 1 === currentPage} onClick={() => paginate(number + 1)}>
                      {number + 1}
                    </Pagination.Item>
                  );
                }
                if (number === currentPage - 1 || number === currentPage || number === currentPage + 1) {
                  return (
                    <Pagination.Item key={number + 1} active={number + 1 === currentPage} onClick={() => paginate(number + 1)}>
                      {number + 1}
                    </Pagination.Item>
                  );
                }
                if (number === 3 && currentPage > 4) {
                  return <Pagination.Ellipsis key="ellipsis1" />;
                }
                if (number >= totalPages - 2) {
                  return (
                    <Pagination.Item key={number + 1} active={number + 1 === currentPage} onClick={() => paginate(number + 1)}>
                      {number + 1}
                    </Pagination.Item>
                  );
                }
                return null;
              })}
              <Pagination.Next onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages} />
            </Pagination>
          )}
        </div>
     </div>

    <h4>Leave a Review</h4>
    <div className='reviewfromLeave'>
      <Form onSubmit={handleSubmit}>
        <Form.Group controlId="anonymous">
          <Form.Check
            type="checkbox"
            label="Post as Anonymous"
            checked={isAnonymous}
            onChange={() => setIsAnonymous(!isAnonymous)}
          />
        </Form.Group>
        <Form.Group controlId="name">
        <Form.Label>Your Name</Form.Label>
          <Form.Control
            type="text"
            value={isAnonymous ? "Anonymous" : name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Your Name"
            disabled={isAnonymous}
            required={!isAnonymous}
          />
        </Form.Group>
        <Form.Group controlId="review" className='mt-2'>
        <Form.Label>Your Review</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            value={review}
            onChange={(e) => setReview(e.target.value)}
            placeholder="Your Review"
           
          />
        </Form.Group>
        
        <Form.Group controlId="rating" className='mt-2'>
        <Form.Label className='mt-1 mb-0'>Your Rating</Form.Label>
          <div className="rating-stars">
            {[...Array(5)].map((_, index) => (
              <label key={index} style={{fontSize:'16px',cursor:"pointer"}}>
                <input
                  type="radio"
                  name="rating"
                  style={{ display: 'none' }}
                  value={index + 1}
                  onClick={() => setRating(index + 1)}
                />
                <FaStar
                  className="star"
                  color={(hover || rating) > index ? "#ffc107" : "#e4e5e9"}
                  onMouseEnter={() => setHover(index + 1)}
                  onMouseLeave={() => setHover(null)}
                />
              </label>
            ))}
          </div>
        </Form.Group>
        <Button variant="primary" type="submit">
          Submit Review
        </Button>
      </Form>
    </div>
  
    

      {/* Modal for submission confirmation */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Submission Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>{modalMessage}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ReviewForm;
